import { DragAndDrop } from "../../../../components/global/DragAndDrop";
import '../../../style.css'
import { motion } from "framer-motion";
import { animationDurationToShowQuestion } from "../../../../config";
import { Fraction } from '../../Fraction'


export const TopPart = ({ state, topNumbers, bottomNumbers, timeduration, result, level }) => {

    return (
        <div
            className={`text-[32px] text-purple-700 flex overflow-hidden items-center w-full border-[3px] rounded-[16px] border-[#2F9EBA] bg-[#FFF] lg:rounded-[20px] 
                       ${state ? "xl:px-[78px] lg:px-[58px] md:px-[49.89px] lg:text-[40px] xl:text-[48px] md:text-[32px] toppartIsStateHeight" : "toppartIsNotStateHeight xl:px-[77.91px] lg:px-[66.09px] md:px-[52px] xl:text-[64px] md:text-[40px] md:text-[40px] lg:text-[48px]"}
                       text-[#FFF] font-bigfatScript justify-between sm:px-[52px] xs:px-[34px] px-[26.63px]
            `}
        >
            <div className={`flex justify-around items-center`}>
                <Fraction value={topNumbers[0]} state={state} fromtop={true}/>
            </div>
            <motion.div
                //animate={{y: [animate.shift() || 0, 0]}}
                transition={{ duration: animationDurationToShowQuestion, type: "tween", ease: "linear" }}
            >
                *
            </motion.div>
            <div className={`flex justify-around items-center`}>
                <Fraction value={bottomNumbers[0]} state={state} fromtop={true}/>
            </div>

            <motion.div
                //animate={{y: [animate.shift() || 0, 0]}}
                transition={{ duration: animationDurationToShowQuestion, type: "tween", ease: "linear" }}
            >
                =
            </motion.div>


            <DragAndDrop
                className={"addingresult"}
                isActive={result === "?" ? false : result}
            >
                <div
                    className={`adding
                    h-[42px]
                    w-[78px]
                    xs:w-[104px]
                    xs:h-[54px]
                    sm:w-[108px] sm:h-[47px]
                                    ${state ? "md:w-[114px] md:h-[49px] lg:w-[150px] lg:h-[69px] xl:w-[200px] xl:h-[82px]" : "md:w-[150px] md:h-[66px] lg:w-[188px] lg:h-[81px] xl:w-[232px] xl:h-[96px]"}
                                    
            rounded-[10px]
            flex
            items-center
            justify-center
            text-white
            ${result === "?" ? "bg-[#E4E4E4]" : "bg-[#85B054]"}
        `}
                >
                    {result === "?" ? "" : result}
                </div>
            </DragAndDrop>
        </div>
    )
}